// Comprovante do malote (#5788) no storage. As regras (tamanho, tipo, caminho) ficam em
// maloteAgrupamento.ts, que é puro e testado; aqui só o acesso ao bucket privado.

import { supabase } from './supabase';
import { BUCKET_MALOTES, caminhoAnexoNf, caminhoComprovante, caminhoComprovanteRetencao, motivoArquivoRecusado } from './maloteAgrupamento';

export async function enviarComprovanteMalote(
  agrupamentoId: number,
  fechamentoId: number,
  arquivo: File,
): Promise<string> {
  const recusa = motivoArquivoRecusado(arquivo);
  if (recusa) throw new Error(recusa);
  const caminho = caminhoComprovante(agrupamentoId, fechamentoId, arquivo.name);
  const { error } = await supabase.storage.from(BUCKET_MALOTES).upload(caminho, arquivo, { upsert: false });
  if (error) throw new Error(`Não foi possível enviar o comprovante: ${error.message}`);
  return caminho;
}

/**
 * Comprovante de retenção do pagamento (#6003). Vai no mesmo bucket privado, com prefixo próprio,
 * e abre pelo mesmo `linkComprovanteMalote` — a assinatura é do bucket, não do prefixo.
 */
export async function enviarComprovanteRetencao(
  agrupamentoId: number,
  fechamentoId: number,
  arquivo: File,
): Promise<string> {
  const recusa = motivoArquivoRecusado(arquivo);
  if (recusa) throw new Error(recusa);
  const caminho = caminhoComprovanteRetencao(agrupamentoId, fechamentoId, arquivo.name);
  const { error } = await supabase.storage.from(BUCKET_MALOTES).upload(caminho, arquivo, { upsert: false });
  if (error) throw new Error(`Não foi possível enviar o comprovante de retenção: ${error.message}`);
  return caminho;
}

/** Anexo da nota fiscal (#5791). Mesmo bucket privado; abre pelo mesmo link assinado. */
export async function enviarAnexoNf(
  agrupamentoId: number,
  fechamentoId: number,
  arquivo: File,
): Promise<string> {
  const recusa = motivoArquivoRecusado(arquivo);
  if (recusa) throw new Error(recusa);
  const caminho = caminhoAnexoNf(agrupamentoId, fechamentoId, arquivo.name);
  const { error } = await supabase.storage.from(BUCKET_MALOTES).upload(caminho, arquivo, { upsert: false });
  if (error) throw new Error(`Não foi possível enviar o anexo da nota: ${error.message}`);
  return caminho;
}

/** Link temporário para abrir o comprovante (10 minutos). */
export async function linkComprovanteMalote(caminho: string): Promise<string> {
  const { data, error } = await supabase.storage.from(BUCKET_MALOTES).createSignedUrl(caminho, 600);
  if (error || !data?.signedUrl) throw new Error('Não foi possível abrir o comprovante agora.');
  return data.signedUrl;
}

/** Apaga o arquivo. Falhar aqui não é erro do usuário: o registro já saiu do fechamento. */
export async function apagarComprovanteMalote(caminho: string | null | undefined): Promise<void> {
  if (!caminho) return;
  const { error } = await supabase.storage.from(BUCKET_MALOTES).remove([caminho]);
  if (error) console.warn('Comprovante do malote não pôde ser apagado:', error.message);
}
